import { Power4, Sine, TimelineMax, TweenLite  } from "gsap";
import * as HLF from "html-living-framework";
import * as Constants from "Data/Constants";

export class KeyboardFocus extends PIXI.Container implements HLF.Input.IKeyboardFocus {
    private readonly _g: PIXI.Graphics;
    private _target: HLF.Input.IFocusable | undefined;

    constructor() {
        super();
        this._g = this.addChild(new PIXI.Graphics());
        this.hide(undefined, true);
    }

    public get target(): HLF.Input.IFocusable | undefined {
        return this._target;
    }

    public show(pFocusable: HLF.Input.IFocusable): void {
        this._target = pFocusable;
        this.redraw();
        this.visible = true;
    }

    public hide(pOnComplete?: () => void, pInstantly: boolean = false): void {
        this._target = undefined;
        this.visible = false;
        pOnComplete?.();
    }

    public redraw(): void {
        if (this._target !== undefined) {
            this.position.copyFrom(this.parent.worldTransform.applyInverse(this._target.getFocusPosition()));
            const size: PIXI.Point = this.parent.worldTransform.applyInverse(this._target.getFocusSize());
            this._g.clear();
            this._g.lineStyle(5, 0xfff7a6, 1, 1);
            this._g.drawRect(-size.x / 2, -size.y / 2, size.x, size.y);
        }
    }

    public destroy(pOptions?: Parameters<typeof HLF.State.prototype.destroy>[0]): void {
        super.destroy(pOptions);
    }
}
